import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class GlobalService {

  constructor() { }

  startEndDateValidation(startDate, endDate) {
    if(startDate === endDate )
    {
      console.log("-------true--------");
      return true;
    }
    else {
      console.log("-------false--------");
      return false;
    }
  }
  endDateValidation(startDate, endDate) {
    if(endDate < startDate )
    {
      console.log("-------false--------");
      return false;
    }
    else {
      console.log("-------true--------");
      return true;
    }
  }
  startTimeEndTime(startHr, endHr, startAMPM, endAMPM) {
    if(startHr!='12' && endHr < startHr && startAMPM === endAMPM) {
      return true;
    }
    else {
      return false;
    }
  } 

  filterEmptyFields(data: any): any {
    let fields = {};
    Object.keys(data).forEach((key) => { 
      console.log(data[key]);
      (data[key] != '' && data[key] != null) ? fields[key] = data[key] : key 
    });
    console.log("fields------------", fields);
    return fields;
  }
}
